export type Theme = 'sky' | 'warm' | 'dark';

export const CUSTOMER_THEME_KEY = 'helpdesk_customer_theme';
export const CUSTOMER_THEME_CHANGED_EVENT = 'helpdesk:customer-theme-changed';

function isTheme(value: string | null): value is Theme {
  return value === 'sky' || value === 'warm' || value === 'dark';
}

export function getStoredTheme(): Theme {
  const stored = localStorage.getItem(CUSTOMER_THEME_KEY);
  return isTheme(stored) ? stored : 'sky';
}

export function applyTheme(theme: Theme, options?: { emit?: boolean }): void {
  localStorage.setItem(CUSTOMER_THEME_KEY, theme);

  if (theme === 'sky') {
    document.documentElement.removeAttribute('data-theme');
  } else {
    document.documentElement.setAttribute('data-theme', theme);
  }

  if (options?.emit !== false) {
    window.dispatchEvent(new Event(CUSTOMER_THEME_CHANGED_EVENT));
  }
}
